import React from 'react';

import Avatar from '../../assets/img/testimonial/avatar-5.png';

const SingleTestimonialThree = (props) => {
  const {
    itemClass,
    description,
    descriptionClass,
    avatarImage,
    authorName,
    designation,
  } = props;
  return (
    <div className={itemClass ? itemClass : 'it-testimonial-2-item'}>
      <div className="it-testimonial-ratting">
        <i className="fa-solid fa-star"></i>
        <i className="fa-solid fa-star"></i>
        <i className="fa-solid fa-star"></i>
        <i className="fa-solid fa-star"></i>
        <i className="fa-solid fa-star"></i>
      </div>
      <div className="it-testimonial-text mb-30">
        <p className={descriptionClass ? descriptionClass : 'text-white'}>
          {description
            ? description
            : `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor  incididunt ut labore et dolore magna aliqua. Ut
          enim ad minim veniam, quis nostrud  exercitation ullamco laboris
          nisi ut aliquip ex ea commodo consequat. Duis aute irure  dolor
          in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla`}
        </p>
      </div>
      <div className="it-testimonial-author-box d-flex align-items-center">
        <div className="it-testimonial-author mr-15">
          <img src={avatarImage ? avatarImage : Avatar} alt="" />
        </div>
        <div className="it-testimonial-author-info">
          <h5 className="text-white">
            {authorName ? authorName : 'Shophie Laurier'}
          </h5>
          <span>{designation ? designation : 'Tripadisor'}</span>
        </div>
      </div>
    </div>
  );
};

export default SingleTestimonialThree;
